import { GitHubCommitResponse } from "../model/CommitModel.js";
import { PredictVulnerabilityResponse } from "../model/PredictResponseModel.js";

export async function RFpredictVulnerabilityAllFiles(
  commitData: GitHubCommitResponse
): Promise<PredictVulnerabilityResponse[]> {
  const results: PredictVulnerabilityResponse[] = [];

  for (const file of commitData.files) {
    const body = {
      commit_stats_total: commitData.stats.total,
      commit_stats_additions: commitData.stats.additions,
      commit_stats_deletions: commitData.stats.deletions,

      additions: file.additions,
      deletions: file.deletions,
      changes: file.changes,
      status: file.status,
      language: file.language ?? file.filename.split(".").pop() ?? "unknown",
    };

    console.log(body)
    console.log("API URL:", process.env.REACT_APP_API_URL);
    const res = await fetch(`${process.env.REACT_APP_API_URL}/RFpredict`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    const prediction = await res.json();

    results.push({
      filename: file.filename,
      predictionProbability: prediction.vulnerable_probability,
      patch: file.patch,
    });
  }

  return results;
}


export async function XGpredictVulnerabilityAllFiles(
  commitData: GitHubCommitResponse
): Promise<PredictVulnerabilityResponse[]> {
  const results: PredictVulnerabilityResponse[] = [];

  for (const file of commitData.files) {
    const body = {
      commit_stats_total: commitData.stats.total,
      commit_stats_additions: commitData.stats.additions,
      commit_stats_deletions: commitData.stats.deletions,

      additions: file.additions,
      deletions: file.deletions,
      changes: file.changes,
      status: file.status,
      language: file.language ?? file.filename.split(".").pop() ?? "unknown",
    };

    console.log(body)
    const res = await fetch(`${process.env.REACT_APP_API_URL}/XGpredict`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    const prediction = await res.json();

    results.push({
      filename: file.filename,
      predictionProbability: prediction.vulnerable_probability,
      patch: file.patch,
    });
  }

  return results;
}
